import IPremium from "@/interfaces/IPremium";
import { Vue, Component } from "vue-property-decorator";
import { Action } from 'vuex-class';

@Component({
  name: 'PremiumIssuance'
})
export default class PremiumIssuance extends Vue {
  @Action private issuePremium!: (form: IPremium) => Promise<void>;

  private isLoading = false;

  private form: IPremium = {
    deviceId: '',
  }

  private async issuePremiumAccess() {
    if (this.disabledForm) {
      return;
    }

    this.isLoading = true;

    try {
      await this.issuePremium(this.form);
      this.$notify({
        group: 'notice',
        title: 'Premium has been issued',
        text: 'Successfully',
        type: 'success'
      });

      this.form.deviceId = '';
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  private get disabledForm() {
    return !this.form.deviceId.trim().length || this.isLoading;
  }
}